// src/encounter/services/use-patient-summary.ts
// GET /api/Patients/GetPatientSummary?PatientId= → aggregate PatientSummary.
// Flutter parity: GetPatientSummaryEvent. AbortSignal forwarded.
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PatientSummary } from '@/types/patient-summary-api';

export function usePatientSummary(patientId: string | null | undefined) {
  return useQuery<PatientSummary>({
    queryKey: ['patient-summary', patientId],
    enabled: !!patientId,
    queryFn: ({ signal }) =>
      get<PatientSummary>(
        `/api/Patients/GetPatientSummary?PatientId=${encodeURIComponent(patientId as string)}`,
        { signal },
      ),
  });
}
